import styled from 'styled-components';

export const ContactContent = styled.div`
  border-radius: 16px;
  background: linear-gradient(135deg, #eff6ff 0%, #faf5ff 100%);
  border: 1px solid #dbeafe;
  padding: 25px;
`;
export const ContactTitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const ContactTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0px;
  color: #212529;
`;
export const EditButton = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
`;
export const TitleIcon = styled.img``;
export const PencilImg = styled.img``;
export const ContactFildes = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;
export const ContactInputBox = styled.div`
  background: #ffffffb2;
  border: 1px solid #ffffff80;
  border-radius: 14px;
  flex: 1;
  padding: 6px 16px;
`;
export const InputLabel = styled.div`
  display: flex;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  gap: 8px;
  color: #6c757d;
`;
export const InputIcon = styled.img``;
export const InputContent = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #212529;
  margin-top: 6px;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const SaveButton = styled.button`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 10px 24px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const CancelButton = styled.button`
  background: transparent;
  color: #6c757d;
  border: 1px solid #dee2e6;
  border-radius: 12px;
  padding: 10px 24px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: #f8f9fa;
    border-color: #adb5bd;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
